import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'donationYear';

export interface FormValues {
  donationStartYear: number | null;
  donationEndYear: number | null;
  isRecurring: boolean | null;
}

export const donationStartYearValidation = yup
  .number()
  .nullable()
  .required('Please, enter the start year');

export const donationEndYearValidation = yup
  .number()
  .nullable()
  .when('isRecurring', {
    is: true,
    then: yup
      .number()
      .nullable()
      .required('Please, enter the end year')
      // eslint-disable-next-line func-names
      .test('is-greater', 'End Year must be greater than the Start Year', function(value) {
        const { donationStartYear: parentDonationStartYear } = this.parent;

        if (!value || !parentDonationStartYear) {
          return true;
        }

        return value > parentDonationStartYear;
      }),
  });

export const validation = yup.object().shape({
  donationStartYear: donationStartYearValidation,
  donationEndYear: donationEndYearValidation,
});
